import NavbarDesktop from "./components/NavbarDesktop";
import NavbarMobile from "./components/NavbarMobile";
import { useSelector } from "react-redux";
import { useEffect, useState } from "react";
import { ThemeProvider } from '@material-ui/core/styles';
import theme from '../../config/muiTheme';
import "./navbar.css";


const Navbar = ({handleOpen, viewedWarning, migrationsStartDate, migrationsEndDate, warningStartDate, warningEndDate}) => {


  const userDni = useSelector((state)=> state.userInstance.docu_nro);
  const [isLogged, setIsLogged] = useState(false);

  useEffect(()=>{
    setIsLogged(!!userDni)
  },[userDni])

  return (
    <>
      <ThemeProvider theme={theme}>
        <NavbarDesktop handleOpen={handleOpen} viewedWarning={viewedWarning} migrationsEndDate={migrationsEndDate} warningStartDate={warningStartDate} warningEndDate={warningEndDate} isLogged={isLogged}/>
        <NavbarMobile handleOpen={handleOpen} viewedWarning={viewedWarning} migrationsStartDate={migrationsStartDate} migrationsEndDate={migrationsEndDate} warningStartDate={warningStartDate} warningEndDate={warningEndDate} isLogged={isLogged}/>
      </ThemeProvider>
    </>
  )
}

export default Navbar;